import React from "react";
import "./footer.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkedAlt,
  faPhoneAlt,
  faEnvelope,
  faAddressCard,
  faExternalLinkAlt,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
import Vilanguage from "../../languages/vi";
import { DomainUserSide } from "utils/configuration";

const LanguageDisplay = Vilanguage;

export default class FooterView extends React.Component {
  render() {
    return (
      <div className="footer-container">
        <div className="container">
          <div className="row mt-3">
            <div className="col-md-6">
              <h5 className="text-center text-uppercase mb-3">
                {LanguageDisplay.footer_titleName}
              </h5>
              <div className="mb-1">
                <FontAwesomeIcon icon={faAddressCard} color="white" className="mr-2" />{" "}
                <span>Địa chỉ: {LanguageDisplay.footer_address}</span>
              </div>
              <div className="mb-1">
                <FontAwesomeIcon icon={faPhoneAlt} color="white" className="mr-2" />{" "}
                <span>
                  Hotline: {LanguageDisplay.footer_hotline}
                  {Vilanguage.footer_fax && (
                    <span> / Fax:{Vilanguage.footer_fax}</span>
                  )}
                </span>
              </div>
              <div className="mb-1">
                <FontAwesomeIcon icon={faEnvelope} color="white" className="mr-2" />{" "}
                <span>E-mail: {LanguageDisplay.footer_email}</span>
              </div>
              <div className="mb-1">
                <FontAwesomeIcon
                  icon={faExternalLinkAlt}
                  color="white"
                  className="mr-2"
                />{" "}
                <span>Website: <a href={LanguageDisplay.footer_website_to} target="_blank" rel="noopener noreferrer">{LanguageDisplay.footer_website}</a></span>
              </div>
            </div>
            <div className="col-md-6">
              <h6 className="text-center mb-1">
                Sản phẩm được phát triển bởi:
              </h6>
              <h5 className="text-center text-uppercase mb-3">
                Công ty cổ phần công nghệ cao CTECH
              </h5>
              <div className="mb-1">
                <FontAwesomeIcon icon={faAddressCard} color="white" className="mr-2" />{" "}
                <span>Địa chỉ: Tầng 1, nhà D, Khu Vinaconex 1, số 289A Khuất Duy Tiến, Quận Cầu Giấy, TP. Hà Nội</span>
              </div>
              <div className="mb-1">
                <FontAwesomeIcon icon={faPhoneAlt} color="white" className="mr-2" />{" "}
                <span>
                  Hotline: 0967.111.625
                </span>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="mb-1">
                  <FontAwesomeIcon icon={faEnvelope} color="white" className="mr-2" />{" "}
                  <span>E-mail: vuha@c2tech.vn</span>
                </div>
                <div>|</div>
                <div className="mb-1">
                  <FontAwesomeIcon
                    icon={faExternalLinkAlt}
                    color="white"
                    className="mr-2"
                  />{" "}
                  <span>Website: <a href="https://c2tech.vn/" target="_blank" rel="noopener noreferrer">https://c2tech.vn/</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
